import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';

export const CAMPAIGNS_KEY_PREFIX = ['campaigns'];
export const campaignsSummaryKey = (dateRangeID) => [...CAMPAIGNS_KEY_PREFIX, dateRangeID];

const useCampaignsSummary = (dateRangeID) => useQuery(
    campaignsSummaryKey(dateRangeID),
    () => apiClient.post('/Statistics/Campaign/', { DateRangeItemID: dateRangeID }).then(r => r.data),
    { staleTime: 5 * 60 * 1000 }
);

export default useCampaignsSummary;
